import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Geometry from './Geometry';
import CoordinateFilter from './CoordinateFilter';
import hasInterface from '../../../../hasInterface';
import Length from '../algorithm/Length';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import Lineal from './Lineal';
import CoordinateSequences from './CoordinateSequences';
import GeometryComponentFilter from './GeometryComponentFilter';
import UnsupportedOperationException from '../../../../java/lang/UnsupportedOperationException';
import Dimension from './Dimension';
import GeometryFilter from './GeometryFilter';
import CoordinateSequenceFilter from './CoordinateSequenceFilter';
import Envelope from './Envelope';
var LineString = /*#__PURE__*/function (_Geometry) {
  _inherits(LineString, _Geometry);
  function LineString() {
    var _this;
    _classCallCheck(this, LineString);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LineString).call(this));
    LineString.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(LineString, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      if (this.isEmpty()) return new Envelope();
      return this._points.expandEnvelope(new Envelope());
    }
  }, {
    key: "isRing",
    value: function isRing() {
      return this.isClosed() && this.isSimple();
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      return this._points.toCoordinateArray();
    }
  }, {
    key: "copyInternal",
    value: function copyInternal() {
      return new LineString(this._points.copy(), this._factory);
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0],
          tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) return false;
        var otherLineString = other;
        if (this._points.size() !== otherLineString._points.size()) return false;
        for (var i = 0; i < this._points.size(); i++) if (!this.equal(this._points.getCoordinate(i), otherLineString._points.getCoordinate(i), tolerance)) return false;
        return true;
      } else {
        return _get(_getPrototypeOf(LineString.prototype), "equalsExact", this).apply(this, arguments);
      }
    }
  }, {
    key: "normalize",
    value: function normalize() {
      for (var i = 0; i < Math.trunc(this._points.size() / 2); i++) {
        var j = this._points.size() - 1 - i;
        if (!this._points.getCoordinate(i).equals(this._points.getCoordinate(j))) {
          if (this._points.getCoordinate(i).compareTo(this._points.getCoordinate(j)) > 0) {
            var copy = this._points.copy();
            CoordinateSequences.reverse(copy);
            this._points = copy;
          }
          return null;
        }
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (this.isEmpty()) return null;
      return this._points.getCoordinate(0);
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      if (this.isClosed()) return Dimension.FALSE;
      return 0;
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      if (this.isEmpty()) return false;
      return this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
    }
  }, {
    key: "reverseInternal",
    value: function reverseInternal() {
      var seq = this._points.copy();
      CoordinateSequences.reverse(seq);
      return this.getFactory().createLineString(seq);
    }
  }, {
    key: "getEndPoint",
    value: function getEndPoint() {
      if (this.isEmpty()) return null;
      return this.getPointN(this.getNumPoints() - 1);
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_LINESTRING;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 1;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return Length.ofLine(this._points);
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      return this._points.size();
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var o = arguments[0];
        var line = o;
        var i = 0;
        var j = 0;
        while (i < this._points.size() && j < line._points.size()) {
          var comparison = this._points.getCoordinate(i).compareTo(line._points.getCoordinate(j));
          if (comparison !== 0) return comparison;
          i++;
          j++;
        }
        if (i < this._points.size()) return 1;
        if (j < line._points.size()) return -1;
        return 0;
      } else if (arguments.length === 2) {
        var _o = arguments[0],
          comp = arguments[1];
        var _line = _o;
        return comp.compare(this._points, _line._points);
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if (hasInterface(arguments[0], CoordinateFilter)) {
        var filter = arguments[0];
        for (var i = 0; i < this._points.size(); i++) filter.filter(this._points.getCoordinate(i));
      } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
        var _filter = arguments[0];
        if (this._points.size() === 0) return null;
        for (var _i = 0; _i < this._points.size(); _i++) {
          _filter.filter(this._points, _i);
          if (_filter.isDone()) break;
        }
        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if (hasInterface(arguments[0], GeometryFilter)) {
        var _filter2 = arguments[0];
        _filter2.filter(this);
      } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
        var _filter3 = arguments[0];
        _filter3.filter(this);
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      throw new UnsupportedOperationException();
    }
  }, {
    key: "isEquivalentClass",
    value: function isEquivalentClass(other) {
      return other instanceof LineString;
    }
  }, {
    key: "getCoordinateN",
    value: function getCoordinateN(n) {
      return this._points.getCoordinate(n);
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_LINESTRING;
    }
  }, {
    key: "getCoordinateSequence",
    value: function getCoordinateSequence() {
      return this._points;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._points.size() === 0;
    }
  }, {
    key: "init",
    value: function init(points) {
      if (points === null) points = this.getFactory().getCoordinateSequenceFactory().create([]);
      if (points.size() === 1) throw new IllegalArgumentException('Invalid number of points in LineString (found ' + points.size() + ' - must be 0 or >= 2)');
      this._points = points;
    }
  }, {
    key: "isCoordinate",
    value: function isCoordinate(pt) {
      for (var i = 0; i < this._points.size(); i++) if (this._points.getCoordinate(i).equals(pt)) return true;
      return false;
    }
  }, {
    key: "getStartPoint",
    value: function getStartPoint() {
      if (this.isEmpty()) return null;
      return this.getPointN(0);
    }
  }, {
    key: "getPointN",
    value: function getPointN(n) {
      return this.getFactory().createPoint(this._points.getCoordinate(n));
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Lineal];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._points = null;
      if (arguments.length === 0) {} else if (arguments.length === 2) {
        var points = arguments[0],
          factory = arguments[1];
        Geometry.constructor_.call(this, factory);
        this.init(points);
      }
    }
  }]);
  return LineString;
}(Geometry);
export { LineString as default };